// FAQ Data
export default {
	"title": "よくあるご質問",
	"categories": [
		{
			"id": "lip-series",
			"title": "DHCのリップシリーズについて",
			"color": "#5c8a46",
			"questions": [
				{
					"id": "q1",
					"question": "薬用化粧品（医薬部外品）と一般化粧品はどう違うのですか？",
					"answer": "薬用化粧品とは厚生労働省が認めた効能効果に有効な成分が配合されている商品を指します。刺激が強いということはないので、一般化粧品と使用方法や使用上の注意などに大きな違いはありません。お肌との相性には個人差もあるので、お肌の悩みや目的、肌質に合わせた商品のご使用をおすすめいたします。",
					"images": []
				},
				{
					"id": "q2",
					"question": "なぜオリーブバージンオイルが唇に良いのですか？",
					"answer": "オリーブオイルに含まれるオレイン酸は肌の皮脂に含まれる成分なのでべたつかず唇に馴染みやすいです。",
					"images": []
				},
				{
					"id": "q3",
					"question": "どのくらいの年齢から使えますか？",
					"answer": "小学生以上からお使いいただけます。",
					"images": []
				},
				{
					"id": "q4",
					"question": "男性でも使えますか？",
					"answer": "性別に関係なくご使用いただけます。",
					"images": []
				},
				{
					"id": "q5",
					"question": "無香料と書いてあるのににおいがするのはどうしてですか？",
					"answer": "無香料とは『香料を使用していない』という意味であり、『無臭』という意味ではありません。化粧品にはさまざまな原料が使用されており、DHCでは天然成分を多く使用していることから商品によっては、その原料自体の香り（原料臭）が感じられることがございます。",
					"images": []
				},
				{
					"id": "q6",
					"question": "リップを口紅の下地として使用できますか？",
					"answer": "ご使用いただけます。",
					"images": []
				},
				{
					"id": "q7",
					"question": "未開封（未使用）のリップはいつまで使用できますか？",
					"answer": "化粧品の品質保持期限はアイテムによっても異なりますが、未開封の場合、適切な保存条件のもと保管していただければ、原則として製造から3年以上は品質が保持されるように製造されています。3年経つとすぐ劣化するというわけではなく、メーカーとして責任をもって品質を保証する期限です。化粧品は高温多湿な場所を避け、日の当たらない棚の中などに保管してください。",
					"images": []
				},
				{
					"id": "q8",
					"question": "開封後のリップはいつまで使用できますか？",
					"answer": "使用状況や保管条件等が異なるため一概には言い切れませんが、できるだけ早めに使用することをおすすめします。異臭がしたり、外観に異常が見られるものは使用しないでください。",
					"images": []
				},
				{
					"id": "q9",
					"question": "保管上の注意点はありますか？",
					"answer": "直射日光のあたる場所、極端に高温多湿の場所での保管はお控えください。",
					"images": []
				},
				{
					"id": "q10",
					"question": "リップは日本製ですか？",
					"answer": "日本製です。",
					"images": []
				},
				{
					"id": "q11",
					"question": "敏感肌だと唇も敏感なのですか？",
					"answer": "唇は顔と違い角層が数層程度と薄く、皮脂腺・汗腺が少ないので皮脂膜もないことからバリア機能が高くありません。顔の中でも乾燥しやすく、また摩擦によるダメージも受けやすいため荒れやすい部位でもあります。よって乾燥により敏感に傾きやすい肌質なのであれば、唇も同様敏感な可能性は高いです。",
					"images": []
				}
			]
		},
		{
			"id": "color-series",
			"title": "カラーリップについて",
			"color": "#f37f80",
			"questions": [
				{
					"id": "q1",
					"question": "発色はどうですか？",
					"answer": "ほんのり血色感のある肌なじみの良い自然な仕上がりです。サッとひと塗りでくすみがちな唇をナチュラルにカバーしてくれます。",
					"images": [
						{
							"src": "./assets/images/faq/faq_01.webp",
							"caption": "シアーオレンジベージュ"
						},
						{
							"src": "./assets/images/faq/faq_02.webp",
							"caption": "シアーブラウンベージュ"
						},
						{
							"src": "./assets/images/faq/faq_03.webp",
							"caption": "シアーローズピンク"
						},
						{
							"src": "./assets/images/faq/faq_04.webp",
							"caption": "シアーレッド"
						},
						{
							"src": "./assets/images/faq/faq_05.webp",
							"caption": "シアーボルドー"
						},
					]
				},
				{
					"id": "q2",
					"question": "マスクにつきにくくする塗り方はありますか？",
					"answer": "唇に塗った後、一度ティッシュオフしてからマスクを着けると、マスクにつきにくくなります。※マスクヘの色移りが全く無いわけではありません。",
					"images": []
				},
				{
					"id": "q3",
					"question": "リップクリームの代わりに使用してもいいですか？",
					"answer": "唇を荒れ・乾燥から守る保湿成分を配合しているので、リップクリームの代わりとしてもご使用いただけます。※就寝時のご使用はお勧めしておりません。",
					"images": []
				},
				{
					"id": "q4",
					"question": "ロ紅の代わりに使用できますか？",
					"answer": "ナチュラルな発色がお好みの方は、口紅の代わりとしてもご使用いただけます。",
					"images": []
				},
				{
					"id": "q5",
					"question": "乾燥した唇でも使用できますか？",
					"answer": "はい、乾燥した唇にもご使用いただけます。保湿・保護作用に優れたオリーブバージンオイルやホホバオイルなどを配合しております。本品は唇を乾燥・荒れから守り、しっとりうるおう唇をキープすることが出来ます。",
					"images": []
				},
				{
					"id": "q6",
					"question": "なぜオリーブバージンオイルが唇に良いのですか？",
					"answer": "オリーブオイルに含まれるオレイン酸は肌の皮脂に含まれる成分なのでべたつかず唇に馴染みやすいです。",
					"images": []
				},
				{
					"id": "q7",
					"question": "紫外線カットカはありますか？",
					"answer": "カラーリップクリームにはSPF22 PA＋＋の紫外線カットカがございます。ダメージを受けやすい唇を紫外線から守ります。",
					"images": []
				},
				{
					"id": "q8",
					"question": "何歳から使えますか？",
					"answer": "中学生以降からのご使用をお勧めしております。",
					"images": []
				},
				{
					"id": "q9",
					"question": "未開封（未使用）の商品はいつまで使用できますか？",
					"answer": "化粧品の品質保持期限はアイテムによっても異なりますが、未開封の場合、適切な保存条件のもと保管していただければ、原則として製造から3年以上は品質が保持されるように製造されています。3年経つとすぐ劣化するというわけではなく、メーカーとして責任をもって品質を保証する期限です。化粧品は高温多湿な場所を避け、日の当たらない棚の中などに保管してください。",
					"images": []
				},
				{
					"id": "q10",
					"question": "開封後はいつまで使用できますか？",
					"answer": "使用状況や保管条件等が異なるため一概には言い切れませんが、できるだけ早めに使用することをおすすめします。異臭がしたり、外観に異常が見られるものは使用しないでください。",
					"images": []
				},
				{
					"id": "q11",
					"question": "保管上の注意点はありますか？",
					"answer": "直射日光のあたる場所、極端に高温多湿の場所での保管はお控えください。",
					"images": []
				},
				{
					"id": "q12",
					"question": "日本製ですか？",
					"answer": "日本製です。",
					"images": []
				}
			]
		}
	]
};
